import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Button } from "@/components/ui/button";
import { Check, ChevronsUpDown, Plus } from "lucide-react";
import { cn } from "@/lib/utils";

export default function Combobox({
  value,
  onChange,
  options,
  placeholder,
  searchPlaceholder,
  emptyText,
  savedHeading,
  addLabel = "hinzufügen",
  testId,
}) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  const showAdd = query.trim() && !options.some((o) => o.toLowerCase() === query.trim().toLowerCase());

  const select = (name) => {
    onChange(name);
    setOpen(false);
    setQuery("");
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          data-testid={`${testId}-trigger`}
          className="w-full justify-between h-11 bg-white border-[#E2E2E2] font-normal text-[#212529] hover:bg-[#FCE7F3]"
        >
          <span className="truncate">{value || <span className="text-[#9AA0A6]">{placeholder}</span>}</span>
          <ChevronsUpDown size={16} className="opacity-50 shrink-0 ml-2" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command>
          <CommandInput
            placeholder={searchPlaceholder}
            value={query}
            onValueChange={setQuery}
            data-testid={`${testId}-search`}
          />
          <CommandList>
            <CommandEmpty>
              <span className="text-sm text-[#5F6368]">{emptyText}</span>
            </CommandEmpty>
            {options.length > 0 && (
              <CommandGroup heading={savedHeading}>
                {options.map((o) => (
                  <CommandItem key={o} value={o} onSelect={() => select(o)} data-testid={`${testId}-option-${o}`}>
                    <Check size={16} className={cn("mr-2 text-[#E6017D]", value === o ? "opacity-100" : "opacity-0")} />
                    {o}
                  </CommandItem>
                ))}
              </CommandGroup>
            )}
            {showAdd && (
              <CommandGroup heading="Neu">
                <CommandItem value={`add-${query}`} onSelect={() => select(query.trim())} data-testid={`${testId}-add-new`}>
                  <Plus size={16} className="mr-2 text-[#E6017D]" />
                  „{query.trim()}" {addLabel}
                </CommandItem>
              </CommandGroup>
            )}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
